import * as React from 'react';

import { cn } from '../lib/cn';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

const sizeMap: Record<SpinnerSize, string> = {
  xs: 'h-3 w-3 border',
  sm: 'h-4 w-4 border',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-2',
};

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: SpinnerSize;
  label?: string;
}

export const Spinner = React.forwardRef<HTMLSpanElement, SpinnerProps>(
  ({ size = 'md', label = 'Loading', className, ...props }, ref) => (
    <span
      ref={ref}
      role="status"
      aria-label={label}
      className={cn('inline-block', className)}
      {...props}
    >
      <span
        className={cn(
          'block animate-spin rounded-full border-current border-t-transparent',
          sizeMap[size],
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  ),
);
Spinner.displayName = 'Spinner';
